import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import Courses from "../../components/layouts/home/courses/Courses";
import Features from "../../components/layouts/home/features/Features";
import Footer from "../../components/layouts/home/footer/Footer";
import Header from "../../components/layouts/home/header/Header";
import Login from "../../components/layouts/home/header/Login";
import Navbar from "../../components/layouts/home/navbar/Navbar";
import { useAuth } from "../../contexts/AuthContext";

/**
 * Landing shell.
 *
 * Was a plain stack with a global `sm:mt-24 mt-12` nudge and each section
 * bringing its own margin guess. Now the navbar is sticky and owns its own
 * spacing, and every section owns its rhythm via the shared Section widget, so
 * this file only decides order and semantics.
 *
 * The section ids stay exactly as they were - the navbar anchors point at them.
 */
function Home() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const { isLogin } = useAuth();

  useEffect(() => {
    if (isLogin) {
      setIsLoginOpen(false);
    }
  }, [isLogin]);

  const handleLoginOpen = () => setIsLoginOpen(true);
  const handleLoginClose = () => setIsLoginOpen(false);

  return (
    <div className="landing-page min-h-dvh bg-canvas text-ink">
      <a href="#main-content" className="landing-skip-link">
        پرش به محتوای اصلی
      </a>
      <Navbar onLoginOpen={handleLoginOpen} />
      <main id="main-content" tabIndex={-1}>
        <Header onLoginOpen={handleLoginOpen} />
        <Features />
        <Courses />
        <Footer />
      </main>
      <Modal open={isLoginOpen} onClose={handleLoginClose}>
        <div className="h-full w-full">
          <Login close={handleLoginClose} />
        </div>
      </Modal>
    </div>
  );
}

export default Home;
